import React, { useEffect } from 'react';
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import commonActions from '../Actions/commonActions'
import customerActions from '../Actions/customerActions'
import routes from '../Constants/routes'
import { withTranslation } from 'react-i18next';
import { useParams, useNavigate } from 'react-router-dom';
import DropDown from '../Components/DropDown';
import { DefaultCard } from "../Components/Card/Card";
import { FormInput } from "../Components/FormComponents/Input/Input";

function CustomerDirectoryEditContainer({ commonActions, customerActions, form, aoCustomers, t }) {

    const {customerId} = useParams();
    const navigate = useNavigate();

    useEffect(() => {
        let directoryCustomer = aoCustomers.find(customer => customer.customerNumber === customerId);
        commonActions.startFormEditing("directoryCustomerEditForm", directoryCustomer)
    }, [])

    const onSaveClick = () => {
        customerActions.updateDirectoryCustomer(form, () => navigate(routes.customerDirectoryContainer));
    }

    const onCancelClick = () => {
        commonActions.cancelFormEditing(form.id, () => navigate(routes.customerDirectoryContainer))
    }

    const onFieldChange = (field, value) => {
        commonActions.changeMultiFormField(form.id, field, value)
    }

    const data = form && form.data;

    if (!data) {
        return null;
    }

    const priorityTypes = [
        {id: 'high', name: t('leadsendemailmodal.high')},
        {id: 'medium', name: t('leadsendemailmodal.medium')},
        {id: 'low', name: t('leadsendemailmodal.low')}
    ]

    return (
        <DefaultCard title={t('customerdirectoryeditcontainer.customerdirectory')}>
            <form className="form-horizontal col-xs-5">
                <FormInput label={t("customerdirectoryeditcontainer.customername")} value={data.customerName} readOnly={true}/>
                <FormInput label={t("customerdirectoryeditcontainer.customernumber")}
                                 value={data.customerNumber} readOnly={true}/>
                <FormInput label={t("customerdirectoryeditcontainer.organizationnumber")}
                                 value={data.organizationNumber} readOnly={true}/>
                <FormInput label={t("customerdirectoryeditcontainer.address")} value={data.email} readOnly={true}/>
                <FormInput label={t("customerdirectoryeditcontainer.postcode")} value={data.postalCode} readOnly={true}/>
                <FormInput label={t("customerdirectoryeditcontainer.city")} value={data.city} readOnly={true}/>
                <br/>
                <DropDown label={t('customerdirectoryeditcontainer.directorypriority')} blankOption={true}
                          onChange={(value) => onFieldChange("priorityType", value)} list={priorityTypes}
                          value={data.priorityType}/>
                <div className="form-group padding-top no-left-margin btn-toolbar d-flex gap-8 align-items-center flex-wrap">
                    <button type="button" className="btn btn-primary btn-sm"
                            onClick={onSaveClick}>{t("customerdirectoryeditcontainer.save")}</button>
                    <button type="button" className="btn btn-default btn-sm"
                            onClick={onCancelClick}>{t("customerdirectoryeditcontainer.cancel")}</button>
                </div>
            </form>
        </DefaultCard>
    )
}


function mapStateToProps(state) {
    return {
        directoryCustomer: state.CustomerReducer.directoryCustomer,
        form: state.CommonReducer.forms && state.CommonReducer.forms.directoryCustomerEditForm,
        aoCustomers: state.CustomerReducer.aoCustomers
    }
}

function mapDispatchToProps(dispatch) {
    return {
        customerActions: bindActionCreators(customerActions, dispatch),
        commonActions: bindActionCreators(commonActions, dispatch)
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(withTranslation()(CustomerDirectoryEditContainer));